// SubscribeAbo.tsx

import {
    Box,
    Typography,
    Paper,
    Button,
    useTheme,
    Snackbar,
    Alert,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableContainer
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { useMemo, useState } from 'react';
import type { Abo } from '../../constants/constants';
import ForestIcon from "@mui/icons-material/Forest";

export default function SubscriptionComparison({ abos }: { abos: Abo[] }) {

    const theme = useTheme();
    const [openSnackbar, setOpenSnackbar] = useState(false);

    // Alle Features sammeln (einmalig)
    const allFeatureLabels = useMemo(() => {
        const featureSet = new Set<string>();
        abos.forEach((abo) =>
            abo.features.forEach((feature) => featureSet.add(feature.label))
        );
        return Array.from(featureSet);
    }, [abos]);

    const subscribeViaChargebee = async (chargebeeId: string) => {
        // Hier Chargebee-Checkout einfügen
        setOpenSnackbar(true);
    };

    return (
        <Box my={2}>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={openSnackbar}
                autoHideDuration={8000}
                onClose={() => setOpenSnackbar(false)}
            >
                <Alert
                    onClose={() => setOpenSnackbar(false)}
                    severity="success"
                    sx={{ width: '100%' }}
                >
                    Mitgliedschaft erfolgreich aktualisiert
                </Alert>
            </Snackbar>

            <TableContainer sx={{ overflowX: 'auto' }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell />
                            {abos.map((abo, i) => (
                                <TableCell
                                    key={i}
                                    align="center"
                                    sx={{
                                        backgroundColor: abo.isHighlighted ? 'secondary.light' : theme.palette.grey[100],
                                        fontWeight: 600
                                    }}
                                >
                                    <Typography variant="h6">{abo.title}</Typography>
                                    <Typography variant="body1" color="primary">
                                        {abo.price} {abo.unit}
                                    </Typography>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {allFeatureLabels.map((label, i) => (
                            <TableRow key={i}>
                                <TableCell sx={{ paddingY: '4px' }}>
                                    {label === 'Pflanze Bäume (Spende 1 CHF an Almighty Tree)' && (
                                        <Box display="flex" alignItems="center" gap={1}>
                                            <Typography variant="body2">{label}</Typography>
                                            <ForestIcon fontSize="small" sx={{ color:'green'}}/>
                                        </Box>
                                    )}

                                    {label !== 'Pflanze Bäume (Spende 1 CHF an Almighty Tree)' && label}
                                </TableCell>

                                {abos.map((abo, j) => {
                                    const feature = abo.features.find((f) => f.label === label);
                                    return (
                                        <TableCell
                                            key={j}
                                            align="center"
                                            sx={{
                                                backgroundColor: abo.isHighlighted ? 'secondary.light' : theme.palette.grey[100],
                                                paddingY: '4px'
                                            }}
                                        >
                                            {feature ? (
                                                typeof feature.value === 'boolean' ? (
                                                    feature.value ? <CheckIcon color="success" /> : '–'
                                                ) : (
                                                    <Typography>{feature.value}</Typography>
                                                )
                                            ) : (
                                                '–'
                                            )}
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        ))}
                        {/*<TableRow>*/}
                        {/*    <TableCell />*/}
                        {/*    {abos.map((abo, i) => (*/}
                        {/*        <TableCell*/}
                        {/*            key={i}*/}
                        {/*            align="center"*/}
                        {/*            sx={{*/}
                        {/*                backgroundColor: abo.isHighlighted ? 'secondary.light' : theme.palette.grey[100]*/}
                        {/*            }}*/}
                        {/*        >*/}
                        {/*            <Button*/}
                        {/*                variant="contained"*/}
                        {/*                disabled={currentAbos.includes(abo.chargebeeId)}*/}
                        {/*                onClick={() => subscribeViaChargebee(abo.chargebeeId)}*/}
                        {/*                fullWidth*/}
                        {/*            >*/}
                        {/*                {currentAbos.includes(abo.chargebeeId)*/}
                        {/*                    ? 'Aktuelles Abo'*/}
                        {/*                    : 'Abo abschliessen'}*/}
                        {/*            </Button>*/}
                        {/*        </TableCell>*/}
                        {/*    ))}*/}
                        {/*</TableRow>*/}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}